import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./components/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import InlineMathSpacingNormalizer from "./components/InlineMathSpacingNormalizer";
import "./nav-buttons-universal.css";
import "./styles/global.css";

import { setTheme } from "./themes/themeManager";
setTheme(localStorage.getItem("theme") || "cyberpunk");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <LanguageProvider>
        <ThemeProvider>
          <InlineMathSpacingNormalizer />
          <App />
        </ThemeProvider>
      </LanguageProvider>
    </AuthProvider>
  </BrowserRouter>
);
